<template>
  <section class="home-view page-shell">
    <div class="hero-copy">
      <div class="eyebrow"><span></span>Your decision companion</div>
      <h1>Less overthinking.<br><em>More living.</em></h1>
      <p>From tonight's dinner to your next big move, find clarity without adding more noise.</p>
    </div>

    <div class="choice-grid">
      <button class="choice-card quick-card" @click="$emit('navigate', 'quick')">
        <span class="choice-number">01</span>
        <span class="choice-icon">✦</span>
        <strong>Pick something small</strong>
        <small>Food, outfits, movies — let chance end it.</small>
        <span class="choice-link">Make a quick choice <b>→</b></span>
      </button>
      <button class="choice-card deep-card" @click="$emit('navigate', 'deep')">
        <span class="choice-number">02</span>
        <span class="choice-icon">◇</span>
        <strong>Think something through</strong>
        <small>Work, money, moving — turn worry into clarity.</small>
        <span class="choice-link">Start a deep decision <b>→</b></span>
      </button>
    </div>

    <section class="home-guides">
      <span class="eyebrow"><span></span>Original content</span>
      <h2>Not ready to choose yet?</h2>
      <p>Read concise guides on decision fatigue, weighted tradeoffs, outside advice, and reviewing past choices without self-blame.</p>
      <button class="soft-button" @click="$emit('navigate', 'guides')">Read decision guides</button>
    </section>

    <div class="daily-card">
      <span class="daily-label">TODAY, DON'T OVERTHINK</span>
      <span class="daily-value"><i>{{ daily.icon }}</i>{{ daily.label }}</span>
      <button @click="shuffleDaily" aria-label="Show another suggestion">↻</button>
    </div>

    <div class="trust-line">
      <span><i>✓</i>No judgement</span><span><i>✓</i>No endless setup</span><span><i>✓</i>Your decisions stay yours</span>
    </div>
  </section>
</template>

<script>
const suggestions = [
  { icon: '☕', label: 'Drink an iced Americano' },
  { icon: '☀', label: 'Take the scenic route' },
  { icon: '♥', label: 'Play your old favorite album' },
  { icon: '→', label: 'Send the message you drafted' },
  { icon: '◇', label: 'Leave one thing for tomorrow' }
]

export default {
  name: 'HomeView',
  data () {
    const day = Math.floor(Date.now() / 86400000)
    return { dailyIndex: day % suggestions.length }
  },
  computed: { daily () { return suggestions[this.dailyIndex] } },
  methods: { shuffleDaily () { this.dailyIndex = (this.dailyIndex + 1) % suggestions.length } }
}
</script>
